import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IUser } from 'modules/core/types';
import { DealSourceProvider } from 'modules/core/enums';
import { ColorDot } from 'modules/core/components/ColorDot/ColorDot';
import { getLoanVariablesCurrentVehicle } from 'store/selectors/RACAffordabilityEngine.selector';

import { IDealSourceData } from '../../../../../modules/core/types/dealSource';
import { VehiclesDescriptionWrapper } from './styles';

interface IVehiclesDescription {
  loanVariables: any;
  showContractInfo: boolean;
  user?: IUser;
  manuallyCreated?: boolean;
  dealSourceData: IDealSourceData;
  tier: string;
}

export const VehiclesDescription: FC<IVehiclesDescription> = ({
  loanVariables,
  showContractInfo,
  user,
  manuallyCreated = false,
  dealSourceData,
  tier,
}) => {
  const { t } = useTranslation();
  const currentVehicleData = useSelector(getLoanVariablesCurrentVehicle);

  const vinLabel = t('components.loanVariablesModal.fields.vin', { vin: loanVariables?.vin });
  const stockLabel = t('components.loanVariablesModal.fields.stock', { stock: loanVariables?.stock });

  return (
    <VehiclesDescriptionWrapper>
      <div className="vehicle-description">{loanVariables.description}</div>
      {showContractInfo && (
        <div className="vehicle-contract-info">
          {user?.isWithInventory && !manuallyCreated ? (
            <>
              <div>{stockLabel}</div>
              <div>{vinLabel}</div>
              <div>{t('components.loanVariablesModal.fields.location', { location: loanVariables?.dealer })}</div>
            </>
          ) : user?.withWholesaleInventory ? (
            <>
              {loanVariables?.stock && !manuallyCreated && <div>{stockLabel}</div>}
              {loanVariables?.vin && <div>{vinLabel}</div>}
              {(() => {
                const color = loanVariables?.color ?? currentVehicleData?.color;
                const colorCanonical = loanVariables?.color_canonical ?? currentVehicleData?.color_canonical;

                return color || colorCanonical ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span>{t('components.loanVariablesModal.fields.color')}</span>
                    <ColorDot canonical={colorCanonical} label={color} gap={4} />
                  </div>
                ) : null;
              })()}
            </>
          ) : loanVariables?.vin ? (
            <div>{vinLabel}</div>
          ) : (
            <></>
          )}
          {dealSourceData?.conversation_id ? (
            <div>
              {t(
                user?.dealSource === DealSourceProvider.DEALER_TRACK
                  ? 'components.loanVariablesModal.fields.dealerTrackApp'
                  : 'components.loanVariablesModal.fields.routeOneApp',
                { conversationID: dealSourceData?.conversation_id },
              )}
            </div>
          ) : (
            <></>
          )}
          <div>{t('components.loanVariablesModal.fields.tier', { index: tier })}</div>
        </div>
      )}
    </VehiclesDescriptionWrapper>
  );
};
